__turbopack_context__.v({
  "iconContainer": "timelineList-module__tDcA5W__iconContainer",
  "itemContent": "timelineList-module__tDcA5W__itemContent",
  "services": "timelineList-module__tDcA5W__services",
  "timelineItem": "timelineList-module__tDcA5W__timelineItem",
  "timelineList": "timelineList-module__tDcA5W__timelineList",
  "values": "timelineList-module__tDcA5W__values",
});
